import React from "react";
import { useTranslation } from "react-i18next";
import "../../stylesheet/components/getstarted/GetStarted.scss";

const GetStartedBanner: React.FC<{ extraClass?: string }> = ({
  extraClass,
}) => {
  const { t, ready } = useTranslation();
  // style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/img/get-started-bg.png'})`}}
  return (
    <div
      className={`container-fluid get-started-wrapper px-0 d-flex justify-content-center position-relative ${
        extraClass ? extraClass : ""
      }`}
    >
      <div className="container get-started-outer px-0">
        {/* <div className="get-started-logo col-md-12 col-lg-5"> */}
        <div className="get-started-logo">
          <img
            src="/img/ze-sailor-head@1024w-compressed.png"
            alt=""
            loading="lazy"
            className="get-started-img"
          />
        </div>
        {/* <div className="col-md-12 col-lg-7 d-flex align-items-center justify-content-lg-end"> */}
        <div className="get-started-info px-2">
          <div className="z-index-3">
            <h3>{ready ? t("misc.getstarted_banner") + "!" : ""}</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStartedBanner;
